// extracted by mini-css-extract-plugin
export default {"noScroll":"__noScroll__r8Uno","overlay":"__overlay__THD5t","close":"__close__a+T9b","content":"__content__KbeJu"};